// Copyright (c) 2026 Finerty Data Ltd. All rights reserved.
//
// This file is part of proprietary software owned by Finerty Data Ltd.
// It is confidential and may not be copied, distributed, modified, or used,
// in whole or in part, without the prior written consent of Finerty Data Ltd.
//
// Author: Ahmed Hosny

import { Button, TextInput } from '@loa/ui-components';

export type AiGenerateRowProps = Readonly<{
  /** Suffix for the row's data-testids, e.g. "needs-objectives". */
  idSuffix: string;
  instruction: string;
  onInstructionChange: (value: string) => void;
  onGenerate: () => void;
  generating: boolean;
  /** Inline failure message (unavailable / parse error); null when healthy. */
  error: string | null;
}>;

/**
 * The "Generate with AI" affordance shared by the builder sections (P3;
 * extended to the Breakthrough Report's authored sections in BR-P6) —
 * mirrors wizard v1's SoS builder AI row: an optional steering-instruction
 * input beside the generate button, with an inline fallback message on
 * failure (manual editing always remains available).
 */
export function AiGenerateRow({
  idSuffix,
  instruction,
  onInstructionChange,
  onGenerate,
  generating,
  error,
}: AiGenerateRowProps) {
  return (
    <div className="pension-builder__ai" data-testid={`builder-ai-row-${idSuffix}`}>
      <div className="pension-builder__ai-row">
        <TextInput
          placeholder="Optional steering instruction for the AI draft…"
          value={instruction}
          onChange={(e) => onInstructionChange(e.target.value)}
          disabled={generating}
          fluid
          data-testid={`builder-ai-instruction-${idSuffix}`}
        />
        <Button
          variant="outlined"
          onClick={onGenerate}
          disabled={generating}
          loading={generating}
          data-testid={`builder-ai-generate-btn-${idSuffix}`}
        >
          Generate with AI
        </Button>
      </div>
      {error && (
        <div className="pension-builder__ai-error" data-testid={`builder-ai-error-${idSuffix}`}>
          {error}
        </div>
      )}
    </div>
  );
}

export default AiGenerateRow;
